import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { getDataAccessAssignments } from '../services'
import type { ResponseArray } from '@/types/shared'
import type { DataAccessAssignment, DataAccessListFilters } from '../types'

export const useDataAccessAssignments = (
    filters: DataAccessListFilters = {}
) => {
    const query = useQueryWithHandler<ResponseArray<DataAccessAssignment>>(
        {
            queryKey: [QUERY_KEYS.DATA_ACCESS_ASSIGNMENTS, 'list', filters],
            queryFn: () =>
                getDataAccessAssignments(filters) as Promise<
                    ResponseArray<DataAccessAssignment>
                >,
            placeholderData: true,
        },
        { showLoading: false }
    )

    const assignments: DataAccessAssignment[] = query.data?.results ?? []
    const total: number = query.data?.pagination?.total ?? 0

    return { ...query, assignments, total }
}
